<template>
    <main class="app-content">
        <div class="container">
            <div class="row">
                <section class="user-details col-12">
                    <div class="c__form--container">
                        <h2>User settings</h2>
                        <vue-form :state="formState" class="form-user-details" @submit.prevent>
                            <div class="row">
                                <div class="form-group col-12 col-sm-6">
                                    <input type="email" readonly v-model="user.username" class="form-control">
                                    <label>Username</label>
                                </div>
                                <div class="form-group col-12 col-sm-6">
                                    <input type="text" v-model="user.role.name" class="form-control" disabled>
                                    <label>Role</label>
                                </div>
                            </div>
                            <div class="row">
                                <validate class="form-group col-12 col-sm-6">
                                    <field-messages class="invalid-feedback" name="firstName" show="$dirty && $invalid">
                                        <div slot="required">First name is required</div>
                                    </field-messages>
                                    <input type="text" required name="firstName" v-model="user.firstName"
                                        class="form-control">
                                    <label>First name</label>
                                </validate>
                                <div class="form-group col-12 col-sm-6">
                                    <input type="text" v-model="user.lastName" class="form-control">
                                    <label>Last name</label>
                                </div>
                            </div>
                            <div class="row">
                                <div class="form-group col-12 col-sm-6">
                                    <input type="text" v-model="user.mobile" class="form-control">
                                    <label>Phone Number</label>
                                </div>
                                <div class="form-group col-12 col-sm-6">
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 justify-content-between d-flex">
                                    <button type="button" :disabled="formState.$invalid" class="btn btn-primary"
                                        @click="saveUser">Save</button>
                                    <button @click="togglePasswordForm" v-show="passwordChangeable" class="btn-link">Change
                                        password</button>
                                </div>
                            </div>
                        </vue-form>
                    </div>
                </section>
                <section class="col-12 password-edit-section" v-show="passwordOpen">
                    <div class="c__form--container">
                        <h2>Change password</h2>
                        <vue-form :state="changePasswordFormState" name="changePassword" @submit.prevent>
                            <div class="row">
                                <div class="col-12">
                                    <validate class="form-group">
                                        <field-messages class="invalid-feedback" name="currentPassword"
                                            show="$dirty && $invalid">
                                            <div slot="required">Current password is required</div>
                                        </field-messages>
                                        <input type="password" name="currentPassword" required class="form-control"
                                            v-model="password.currentPassword">
                                        <label>Current Password</label>
                                    </validate>
                                </div>

                                <div class="col-12">
                                    <validate class="form-group ">
                                        <field-messages class="invalid-feedback" name="newPassword"
                                            show="$dirty && $invalid">
                                            <div slot="required">New password is required</div>
                                        </field-messages>
                                        <input type="password" name="newPassword" required class="form-control"
                                            v-model="password.password.first">
                                        <label>New Password</label>
                                    </validate>
                                </div>

                                <div class="col-12">
                                    <validate class="form-group ">
                                        <field-messages class="invalid-feedback" name="confirmPassword"
                                            show="$dirty && $invalid">
                                            <div slot="required">Confirm password is required</div>
                                            <div slot="matches">Password does not match</div>
                                        </field-messages>
                                        <input type="password" name="confirmPassword" :matches="password.password.first"
                                            required class="form-control" v-model="password.password.second">
                                        <label>Confirm new Password</label>
                                    </validate>
                                </div>
                                <div class="col-12">
                                    <button type="button" v-on:click="changePassword"
                                        :disabled="changePasswordFormState.$invalid" class="btn btn-primary">Change
                                        Password</button>
                                </div>
                            </div>
                        </vue-form>
                    </div>
                </section>
            </div>
        </div>
        <result-message ref="resultMessage" :errors="errors"></result-message>
    </main>
</template>

<script>
import userServices from '../services/users';
import store from '../store';
import ResultMessage from '../helpers/ResultMessage';
import { refreshPageMixin } from '../mixins/refreshPage';

export default {
    mixins: [refreshPageMixin],
    name: 'AccountSettings',
    components: {
        ResultMessage
    },
    data() {
        return {
            passwordChangeable: true,
            passwordOpen: false,
            user: {
                role: {
                    name: ""
                },
            },
            password: {
                password: {
                    first: ""
                },
            },
            changePasswordFormState: {},
            formState: {},
            errors: {
                type: Object | Error,
                $clean: true
            },
            currentUser: {},
        }
    },
    methods: {
        togglePasswordForm() {
            this.passwordOpen = !this.passwordOpen;
        },
        getUserSettings() {
            if (this.$store.state.user && this.$store.state.user.passwordChangeable === false) {
                this.passwordChangeable = false;
                console.log("this")
            }
            userServices.getProfile().then(user => {
                this.user = user;
                this.user.role = this.user.role.value;
                let self = this;
                this.user.selectedPermissions = [];
                if (typeof this.user.permissions !== 'undefined') {
                    this.user.permissions.forEach(function (permission) {
                        self.user.selectedPermissions.push(permission.agency)
                    });
                }
            });
        },
        saveUser() {
            // Set agencies to an empty array so it's not undefined for buildPermissions function
            userServices
                .setAgencies([])
                .updateUser(this.user).then(user => {
                    this.getUserSettings();
                    store.state.welcomeMsg = user.firstName;
                    this.$refs.resultMessage.showSuccess('User settings updated');
                }).catch((errors) => {
                    this.errors = errors;
                });
        },
        changePassword() {
            userServices.updatePassword(this.password).then(user => {
                this.togglePasswordForm();
            }).catch((errors) => {
                this.errors = errors;
            });
        },
    },
    watch: {
        hashChanged(newVal) {
            if (newVal) {
                this.getUserSettings();
            }
        }
    },
    mounted() {
        this.getUserSettings();
    }
}
</script>

<style lang="scss" scoped>@import './src/assets/sass/vue';

.form-user-details button.btn-link {
    height: 21px;
    flex: none;
}</style>
